
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/application-development",
      function () {
        return require("private-next-pages/cases/application-development/index.tsx");
      }
    ]);
  